function CheckAllBusinesses() {
    $('#chkAllBusinesses').is(':checked') ? $('.AllBusinessesInputSection').show() : $('.AllBusinessesInputSection').hide();
    if (!$('#chkAllBusinesses').is(':checked')) {
        $('.AllBusinessesInputSection :checkbox').prop('checked', false);
    }
}